<template>
  <div test-id="main">
    <div class="bg-root lg:p-8">
      <div
        class="flex flex-col items-center justify-center rounded-lg shadow-xs border px-5 py-5 transition-all duration-300 ease-linear"
      >
        <p class="font-light text-sm lg:text-base">You will send exactly</p>
        <h3 class="text-2xl mt-1">
          {{
            parseMoneyAll(
              transferDetails.debitAmount + transferDetails.partnerCommission,
              country.currency
            )
          }}
        </h3>
        <p class="flex items-center gap-x-3 mt-2">
          <span
            class="border-b border-solid border-gray-200 w-10 lg:w-28"
          ></span>
          <span
            @click="toggleShow('showBreakDown')"
            class="font-light text-xs lg:text-sm text-primary flex items-center gap-x-1 cursor-pointer"
            ><span>See Breakdown</span>
            <div
              class="transition-all duration-300 transform"
              :class="showBreakDown ? '-rotate-90' : 'rotate-90'"
            >
              <arrow-right-icon />
            </div>
          </span>
          <span
            class="border-b border-solid w-10 lg:w-28 border-gray-200"
          ></span>
        </p>
        <transition name="fade-in">
          <ul
            v-if="showBreakDown"
            class="w-full text-xs lg:text-sm font-light px-2 lg:px-4 mt-4 text-root-4"
          >
            <li class="flex items-center justify-between mb-4">
              <span>Our fees </span>
              <span>{{
                parseMoneyAll(transferDetails.fees, country.currency)
              }}</span>
            </li>
            <li class="flex items-center justify-between mb-4">
              <span>Amount converted</span>
              <span>
                {{
                  parseMoneyAll(
                    transferDetails.debitAmount - transferDetails.fees,
                    country.currency
                  )
                }}</span
              >
            </li>
            <li class="flex items-center justify-between mb-4">
              <span>Exchange rate</span>
              <!-- <span>{{ transactionDetails.exchangeRate }}</span> -->
              <div class="text-root-4">
                1
                {{
                  !this.isDivisionOperator ? activeCurrency : secondaryCurrency
                }}
                = {{ exchangeRateBase }}
                {{
                  !this.isDivisionOperator ? secondaryCurrency : activeCurrency
                }}
              </div>
            </li>
            <li class="flex items-center justify-between mb-4">
              <span>Recipient would receive</span>
              <span class="font-semibold"
                >{{ convertValueTo2DP(transferDetails.recipientAmount || 0) }}
                {{ country2.currency }}</span
              >
            </li>
          </ul>
        </transition>
      </div>
      <select-deposit-method
        v-if="showSelectDepositMethod"
        @initiateTransferHandler="initiateTransferHandler"
        :isLoading="isLoading"
      />
      <div
        v-if="showBankTransferDetails"
        class="border-main rounded-lg px-4 lg:px-8 py-3 mt-5"
      >
        <div class="px-8 mt-3">
          <copy-all :details="paymentDetails" />
        </div>
        <div
          class="px-4 lg:px-12 py-3 lg:py-8 rounded-lg shadow-xs mt-2 bg-muted"
        >
          <div class="flex items-center justify-between mb-5">
            <div>
              <div class="font-light text-xs text-fg-muted">Bank Name:</div>
              <div class="capitalize font-medium text-sm lg:text-base">
                {{ paymentDetails.bankName || '-' }}
              </div>
            </div>
            <div
              class="justify-self-center cursor-pointer"
              v-clipboard:copy="paymentDetails.bankName"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </div>
          </div>
          <div class="flex items-center justify-between mb-5">
            <div>
              <div class="font-light text-xs text-fg-muted">
                Account Number:
              </div>
              <div class="capitalize font-medium text-sm lg:text-base">
                {{ paymentDetails.accountNumber || '-' }}
              </div>
            </div>
            <div
              v-if="paymentDetails.accountNumber"
              class="justify-self-center cursor-pointer"
              v-clipboard:copy="paymentDetails.accountNumber"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </div>
          </div>
          <div class="flex items-center justify-between mb-5">
            <div>
              <div class="font-light text-xs text-fg-muted">Account Name:</div>
              <div class="capitalize font-medium text-sm lg:text-base">
                {{ paymentDetails.accountName || '-' }}
              </div>
            </div>
            <div
              v-if="paymentDetails.accountName"
              class="justify-self-center cursor-pointer"
              v-clipboard:copy="paymentDetails.accountName"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <div>
              <div class="font-light text-xs text-fg-muted">Reference:</div>
              <div class="capitalize font-medium text-sm lg:text-base">
                {{ transferReference || '-' }}
              </div>
            </div>
            <div
              class="justify-self-center cursor-pointer"
              v-clipboard:copy="transferReference"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-y-5 mt-6">
          <div
            @click="done"
            class="text-xs lg:text-sm font-light hover:opacity-80 bg-primary rounded-lg shadow-sm flex justify-center py-3.5 lg:py-4 cursor-pointer text-white w-full hover-animation-subtle"
          >
            I have made payment
          </div>
          <div
            class="text-xs lg:text-sm font-light hover:opacity-80 bg-subtle border-main rounded-lg shadow-sm flex justify-center py-3.5 lg:py-4 cursor-pointer text-primary w-full hover-animation-subtle"
            @click="$emit('goToEnterAmount')"
          >
            Transfer later
          </div>
        </div>
        <div
          class="flex items-center justify-center text-center text-xs lg:text-sm text-primary cursor-pointer font-semibold my-8"
        >
          <p
            class="flex items-center justify-center text-center gap-x-3 hover-animation-opacity"
            @click="generatePdf"
          >
            <download-icon />
            <span>Download PDF</span>
          </p>
        </div>
      </div>
      <vuehtml2pdf
        :manual-pagination="true"
        :filename="fileName"
        :pdf-quality="2"
        pdf-format="a4"
        pdf-content-width="800px"
        :enable-download="true"
        ref="DownloadComp"
        :show-layout="false"
      >
        <section slot="pdf-content">
          <terminal-transfer-details />
        </section>
      </vuehtml2pdf>
      <transaction-processing
        v-if="showTransferProcessingDialog"
        :showDialog="showTransferProcessingDialog"
        @closeDialog="closeTransferProcessingDialog"
        @showSuccess="showSuccess"
      />
      <beneficiary-saved-success-dialog
        v-if="showSuccessDialog"
        :showDialog="showSuccessDialog"
        @closeDialog="closeSuccessDialog"
      />
    </div>
    <vuehtml2pdf
      :manual-pagination="true"
      :filename="fileName"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-content-width="800px"
      :enable-download="true"
      ref="DownloadComp"
      :show-layout="false"
    >
      <section slot="pdf-content">
        <terminal-transfer-details />
      </section>
    </vuehtml2pdf>
    <transaction-processing
      v-if="showTransferProcessingDialog"
      :showDialog="showTransferProcessingDialog"
      @closeDialog="closeTransferProcessingDialog"
      @showSuccess="showSuccess"
    />
    <beneficiary-saved-success-dialog
      v-if="showSuccessDialog"
      :showDialog="showSuccessDialog"
      @closeDialog="closeSuccessDialog"
    />
    <verify-auth-dialog
      :authState="authState"
      v-if="showVerifyAuthDialog"
      :showDialog="showVerifyAuthDialog"
      @closeDialog="closeDialog('showVerifyAuthDialog')"
      @initiateHoldingsTransfer="initiateHoldingsTransfer"
    />
  </div>
</template>

<script>
import country from '@/mixins/getCountryDetails.js'
import exchangeRate from '@/mixins/localDeposit.js'
import terminal from '@/mixins/terminal.js'
import {
  ConvertValueToXDP,
  ParseMoneyNaira,
  ParseMoneyLocal,
  ParseMoneyAll,
  ParseMoney
} from '@/utils/helpers'
export default {
  mixins: [exchangeRate, country, terminal],
  name: 'MakePaymentLocal',
  props: {
    useType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showTransferProcessingDialog: false,
      showSuccessDialog: false,
      showBreakDown: false,
      showBankTransferDetails: false,
      showSelectDepositMethod: true,
      isLoading: false,
      showVerifyAuthDialog: false,
      authState: 'holdingsTransfer'
    }
  },
  methods: {
    initiateTransferHandler () {
      if (this.isBankTransferMethod) {
        const payload = {
          ...this.currentTransferDetails,
          source: 'local_transfer',
          localDeposit: {
            amount: this.transferDetails.debitAmount,
            currency: this.country.currency
          }
        }
        if (this.transferDetails.partnerCommission) {
          payload.businessCommission = this.transferDetails.partnerCommission
        }
        this.initiateTerminalTransfer(payload)
      } else {
        this.showVerifyAuthDialog = true
      }
    },
    toggleShow (arg) {
      this[arg] = !this[arg]
    },
    parseMoneyAll (val, currency) {
      return ParseMoneyAll(val, currency)
    },
    generatePdf () {
      this.$refs.DownloadComp.generatePdf()
    },
    closeTransferProcessingDialog () {
      this.showTransferProcessingDialog = false
    },
    parseMoneyNaira (val) {
      return ParseMoneyNaira(val)
    },
    parseMoneyLocal (val, symbol) {
      return ParseMoneyLocal(val, symbol)
    },
    parseMoney (val) {
      return ParseMoney(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    handleBankTransfer () {
      this.showSelectDepositMethod = false
      this.showBankTransferDetails = true
    },
    done () {
      if (this.routeName === 'terminal') {
        this.showTransferProcessingDialog = true
      } else {
        this.$store.dispatch('transactions/activeFilter', 'transfer')
        this.$router.push({ name: 'transactions' })
      }
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard')
    },
    convertValueTo2DP (val) {
      return ConvertValueToXDP(val, 2)
    },
    showSuccess () {
      this.showSuccessDialog = true
    },
    closeSuccessDialog () {
      this.$router.push({ name: 'transactions' })
    },
    closeDialog (arg) {
      this[arg] = false
    }
  },
  components: {
    ArrowRightIcon: () => import('@/assets/v2/icons/ArrowRightIcon.vue'),
    Transition: () =>
      import('@/components/v2/animation/transition/Transition.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    TerminalTransferDetails: () =>
      import(
        '@/components/terminal/terminalSkeleton/TerminalTransferDetails.vue'
      ),
    TransactionProcessing: () =>
      import('@/components/terminal/TransactionProcessing.vue'),
    BeneficiarySavedSuccessDialog: () =>
      import('@/components/terminal/BeneficiarySavedSuccessDialog.vue'),
    DownloadIcon: () => import('@/assets/v2/icons/DownloadIcon.vue'),
    SelectDepositMethod: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment/SelectDepositMethod.vue'
      ),
    VerifyAuthDialog: () => import('@/components/v2/auth/VerifyAuthDialog.vue')
  },
  computed: {
    fileName () {
      return `${process.env.VUE_APP_TENANT_TITLE} Terminal Transfer`
    },
    isBankTransferMethod () {
      return this.depositMethod === 'bank transfer'
    },
    routeName () {
      return this.$route.name
    },
    usedBeneficiary () {
      return this.$store.state.terminal.usedBeneficiary
    },
    recipientInfo () {
      return (
        this.$store.state.terminal.transferTerminalDetails
          .recipientInformation || {}
      )
    },
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    paymentDetails () {
      const details = this.getLocalDepositDetails(
        this.country.currency,
        this.country2.currency
      )
      return details?.account_details || {}
    },
    isExternalApi () {
      return this.useType === 'externalApi'
    },
    transferReference () {
      const details =
        this.$store.state.terminal.transferInfo?.localDepositRef || '-'
      const ref =
        this.$store.state.externalApi.settledTransferInfo.localDepositRef
      return this.isExternalApi ? ref : details
    },
    fromBalance () {
      return this.$store.state.terminal.terminalTransferType === 'fromBalance'
    }
  }
}
</script>
